<ftr-icon [icon]="icon()" size="Regular" aria-hidden="true"></ftr-icon>
<span class="label" aria-hidden="true">{{ label() }}</span>
@if (numberOfResults() !== undefined) {
  <span class="result-count">{{ numberOfResults() }}</span>
}
